import { spaceCadet, kiwiGreen } from '@cogneed/react-utils';
import {
  alpha, BoxProps, Box, styled,
} from '@mui/material';

interface ExtendedBoxProps extends BoxProps {
  color: string
}

const StyledBox = styled((props: ExtendedBoxProps) => {
  const { color, ...rest } = props;

  return <Box {...rest} />;
})(({ color }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  '& svg': {
    display: 'block',
    fontSize: 12,
    color: 'inherit',
  },

  '& .MuiAccordion-root': {
    backgroundColor: alpha(spaceCadet[100], 0.3),
    border: `solid 1px ${spaceCadet[100]}`,
  },

  '& .MuiAccordionSummary-root': {
    minHeight: 36,
    '&.Mui-expanded': {
      minHeight: 36,
    },
    justifyContent: 'space-between',
    gap: 8,
    '& .MuiAccordionSummary-content': {
      overflow: 'hidden',
      gap: 8,
      margin: '4px 0px',
      flexGrow: 0,
      display: 'flex',
      alignItems: 'center',

      '& svg': {
        display: 'block',
        fontSize: 16,
        color: spaceCadet[400],
      },

      '& .MuiTypography-subtitle1': {
        overflow: 'hidden',
        fontSize: 12,
        lineHeight: '16px',
        textTransform: 'uppercase',
        fontWeight: 700,
        padding: '2px 8px',
        borderRadius: 4,
        display: 'flex',
        color,
        backgroundColor: alpha(color, 0.1),
        textWrap: 'nowrap',
        textOverflow: 'ellipsis',
      },
    },
    '&.completed': {
      '& svg': {
        color: kiwiGreen[700],
      },
      '& .MuiTypography-subtitle1': {
        textDecoration: 'line-through',
      },
    },
  },

  '& .MuiAccordionDetails-root': {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    '& ul': {
      margin: 0,
      marginTop: 4,
      fontWeight: 300,
      fontStyle: 'italic',
      paddingLeft: 24,

      '& li': {
        fontSize: 14,
        '::before': {
          content: 'open-quote',
        },
        '::after': {
          content: 'close-quote',
        },
      },
    },
  },
  '& .PlaygroundEditorTheme__paragraph': {
    fontSize: 14,
  },
  '& .MuiTypography-subtitle2': {
    fontSize: 14,
    textTransform: 'none',
    fontWeight: 600,
    lineHeight: '16px',
    color: spaceCadet[400],
  },
}));

export default StyledBox;
